import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

const accountManagerUrl = "https://am.ticketmaster.com/reignfc/";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Matches ",
    description: "Select the matches you wish to attend with your group.",
  },
  {
    icon: <TbShirtSport />,
    title: "Login to Account Manager",
    description: (
      <>
        Click Continue and connect to your{" "}
        <Link
          href={accountManagerUrl}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Seattle Reign FC
        </Link>{" "}
        account using our secure Ticketmaster login.
      </>
    ),
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for your group.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available to be managed in your{" "}
        <Link
          target={"_blank"}
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href={accountManagerUrl}
        >
          Seattle Reign FC
        </Link>{" "}
        Account Manager within 24 hours.
      </>
    ),
  },
];

// TODO(marketing): confirm Reign Groups FAQ copy. Placeholder set below —
// only the 10-ticket minimum is assumed from the config (unconfirmed).
export const faqs = [
  {
    title: "What is a group ticket order?",
    description:
      "Bring your friends, family, coworkers, or classmates to the match. Group orders let you purchase seats together for the matches you choose (subject to availability).",
  },
  {
    title: "What is the minimum number of tickets for a group?",
    description: "A minimum of 10 tickets is required per group order.",
  },
];

export function CheckoutTerms() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        href={"https://www.attend.tech/terms-of-use"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>
      ,{" "}
      <Link
        href={"https://www.attend.tech/privacy-policy"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      , and{" "}
      <Link
        href={"https://www.reignfc.com/tickets/ticket-policy"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Seattle Reign FC Ticket Policy
      </Link>
      .
    </>
  );
}
